import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, viewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ZipDownloadService } from '../../services/zip-download.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { getQuestionnaireTemplate } from '../../pre-ready-tepmlate';
import { init } from '../editorconfig';
import { IdexFromComponent } from '../idex-scheme-list/idex-from/idex-from.component';

@Component({
  selector: 'app-firm-response-submission',
  standalone: false,
  templateUrl: './firm-response-submission.component.html',
})
export class FirmResponseSubmissionComponent implements OnInit, OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
   @ViewChild(IdexFromComponent) idexForm!: IdexFromComponent;

  visible: boolean = false;
  commentForm: FormGroup;
  selectedVendor: any;
  @Input() id: any
  @Input() url: any
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() format: any;
  @Input() stepDetails: any;
  @Input() schemeType: any;
  @Input() isVisibleResponseUpload: boolean = false;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() proposalName: any;
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  questionnaireData: EditorComponent['init'] = init;
  questionnaireTemplate: any = getQuestionnaireTemplate();
  questionnaireContent: string = '';  // bound to editor
  questionnaireID:any;
  challengeForm: FormGroup;

  selectedVendorList: any[] = [];
  venderList: any[] = []
  filteredVendors: any[];
  payload: {
    proposal_id: any;
    proposal_name: any;
    scheme: any;
    schemeId: any;
  };
  selectedMasterVendor: any
  masterVendorList: any
  selectedvendor: any
  title: string
  incubatorList: any;
  resId: any;

  // Upload DPR component properties
  proposalForm!: FormGroup;
  agencieForm!: FormGroup;
  readonly requiredValidator = Validators.required;

  apiUrl = environment.APIUrl
  docuemntList: any;
  baseUrl = environment.APIUrl;
  winners: any;
  vendors: any
  activeIndex: number | null = null;

  // CSV Upload properties from revenue-vendors
  uploadedCsvFile: File | null = null;
  uploadedFileName: string | null = null;
  csvfile: File | null = null;

  private subscriptions = new Subscription();
  cols: any[] = [
    { field: 'name', header: 'Name', filterType: 'text' },
    { field: 'contact', header: 'Contact Person', filterType: 'text' },
    { field: 'phone_number', header: 'Contact Number', filterType: 'text' },
    { field: 'email', header: 'Email', filterType: 'text' },
  ];
  incubator_cols: any[] = [
    { field: 'name', header: ' Name', filterType: 'text', width: '200px' },
    { field: 'phone_number', header: 'Phone Number', filterType: 'text', width: '300px' },
    { field: 'address', header: 'Address', filterType: 'text', width: '300px' },
  ];
  systemForm: FormGroup;
  userID: any;
  totalRecords: number = 0;
  

  expandedSections = {
    documentUploads: false,
  }
  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private zipDownloadService: ZipDownloadService,
    
  ) {
    this.commentForm = this.fb.group({
      vendor: ['', Validators.required],
      name: ['', Validators.required],
      contactPerson: ['', [Validators.required, Validators.pattern(/^[A-Za-z\s]+$/)]],

      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required]],
      address: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 ,.()&-]+$')]],
      taxNumber: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9 ,.()&-]+$')]],
      bankDetails: ['', Validators.required],
    });
    this.systemForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      selectedOptions: [[]]
    });
    this.proposalForm = this.fb.group({
      comment: ['', Validators.required],
    });
    this.agencieForm = this.fb.group({
      agencie_1: ['', Validators.required],
      agencie_2: ['', Validators.required],
      agencie_3: ['', Validators.required],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role
    this.tableColumns = this.tableColumns.map((col: any) => ({
      ...col,
      visible: col.visible !== false,
    }));
    this.syncVisibleColumns();
  }

  syncVisibleColumns() {
    this.filterColoum = this.tableColumns.filter((col: any) => col.visible !== false);
  }
  proposal:any;
  ngOnInit(): void {
    
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      const scheme = params['scheme'];
      const schemeId = params['scheme'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
        scheme: scheme,
        schemeId: schemeId
      }
    });
    if (this.format === 'evaluation') {
      this.getData();
    } else if (this.format === 'upload') {
      this.getVendorList();
    } else if (this.format === 'pds-pru-evaluation') {
      this.getVenderPsuPruEvaluation();
    } else if (this.format === 'pds-pru') {
      this.getPdsPru();
    } else if (this.format === 'screening') {
      this.getScreenVendorList();
    }

    if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      this.title = 'List of Development Agencies'
    } else {
      this.title = 'List of Vendors'
    }
    // Call getData after payload is initialized
     this.questionnaireContent = this.questionnaireTemplate;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }



  // Vendor component methods
  getVendorList() {
    this.api.getAPI(`/master/vendor/`).subscribe((res: any) => {
      this.masterVendorList = res.data;
    });
    this.getVendorIdentification();
  }

  getScreenVendorList() {
    this.api.getAPI(`/idex/vendor-identification/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`).subscribe((res: any) => {
      const vendorMap = res?.vendor || {};
      this.winners = Object.values(vendorMap).flat();
    });
  }


  removeVendor(vendor: any) {
    let url;
    if (this.schemeType == 'idex') {
      url = `/idex/vendor-identification/${vendor.id}/`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/vendor-identification/${vendor.id}/`
    } else {
      url = `/revenue/vendor-identification/${vendor.id}/`
    }
    const sub = this.api.deleteAPI(url).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Vendor deleted successfully'
      });
      this.selectedVendorList = this.selectedVendorList.filter(v => v !== vendor);
    });
    this.subscriptions.add(sub);
  }

  getVendorIdentification() {
    let url;
    if (this.schemeType == 'idex') {
      url = `/idex/vendor-identification/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`;
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/vendor-identification/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`;
    } else if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/vendor-identification/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`;
    } else {
      url = `/revenue/vendor-identification/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`;
    }

    this.api.getAPI(url).subscribe((res: any) => {
      this.resId = res?.id;
      // this.tableData=res.vender
      const vendorMap = res?.vender || res?.vendor || {};

      // if vendorMap is like your sample JSON (object with arrays as values)
      this.winners = Object.values(vendorMap).flat();
       this.questionnaireContent = res?.questionnaire ?? this.questionnaireTemplate;
      this.questionnaireID = res?.id;
      console.log("questionary id", this.questionnaireID);

    });
  }


  postVendorIdentification(e?: any) {
    let payload;
    if (this.schemeType == 'tdf') {
      payload = {
        step: this.resId,
        proposal_step: this.id,
        vendor: e.value.id,
        status: 1
      }
    } else {
      payload = {
        proposal_step: this.id,
        vendor: e.value.id,
        status: 1
      }
    }
    let url;
    if (this.schemeType == 'idex') {
      url = `/idex/vendor-identification/`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/vendor-identification/`
    } else if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/vendor-identification/`
    } else {
      url = `/revenue/vendor-identification/`
    }
    const sub = this.api.postAPI(url, payload).subscribe((res: any) => {
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Vendor Identification added successfully'
        });
        this.getVendorIdentification();
      }
    });
    this.subscriptions.add(sub);
  }

  onSelect(event: any) {
    this.selectedVendorList.push(event.value);
    this.selectedVendor = null;
    this.commentForm.reset();
    this.postVendorIdentification(event);
  }

  addVendorFromMaster() {
    if (this.selectedMasterVendor) {
      let payload;
      if (this.schemeType == 'tdf') {
        payload = {
          proposal_step: this.id,
          step: this.resId,
          vendor_id: this.selectedMasterVendor,
          status: 1
        };
      } else if (this.schemeType == 'idex') {
        payload = {
          step: this.resId,
          vendor_id: this.selectedMasterVendor,
          status: 1
        };
      } else {
        payload = {
          step: this.resId,
          vendor_id: this.selectedMasterVendor,
          status: 1
        };
      }
      this.winners?.forEach((vendor: any) => {
        if (this.selectedMasterVendor?.includes(vendor?.vendor.id)) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Duplicate',
            detail: `${vendor.vendor.name} already added.`
          });
          return;
        }
      });


      let url;
      if (this.schemeType == 'idex') {
        url = `/idex/vendor-identification/`
      } else if (this.schemeType == 'tdf') {
        url = `/tdf/vendor-identification/`
      } else if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
        url = `/make1/vendor-identification/`
      } else {
        url = `/revenue/vendor-identification/`
      }

      const sub = this.api.postAPI(url, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor added to identification.'
          });
          this.selectedMasterVendor = null;
          this.getVendorIdentification();
          // this.getData();// Refresh the table
        },
        error: (err: any) => {
          console.error('Error adding vendor from master:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.message || 'Failed to add vendor from master. Please try again.'
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }

  openAdd() {
    this.visible = true;
    this.commentForm.reset();
  }

  onSubmit() {
    let payload;
    let url;
    if (this.schemeType == 'idex') {
      payload = {
        proposal_step: this.id,
        // name: this.systemForm.get('name')?.value,
        company_name: this.systemForm.get('name')?.value,
        description: this.systemForm.get('description')?.value,
        scheme: parseInt(this.payload.scheme)
      }
      // url = `/idex/add/vendor/`
      url = `/idex/vendor-identification/`
     if( this.stepDetails?.step_mapping?.scheme?.id == 7 ){
        this.idexForm?.stepSaveApiCall();
        return;
     };
   
    } else if (this.schemeType == 'tdf') {
      payload = {
        step: this.resId,
        proposal_step: this.id,
        // name: this.commentForm.get('vendor')?.value,
        company_name: this.commentForm.get('vendor')?.value,
        name: this.commentForm.get('name')?.value,
        email: this.commentForm.get('email')?.value,
        contact: this.commentForm.get('contactPerson')?.value,
        phone_number: this.commentForm.get('phone')?.value,
        address: this.commentForm.get('address')?.value,
        tax_number: this.commentForm.get('taxNumber')?.value,
        bank_details: this.commentForm.get('bankDetails')?.value,
        status: 1
      };
      url = `/tdf/vendor-identification/`
    } else if (this.schemeType != 'makeI' && this.schemeType != 'makeII' && this.schemeType != 'makeIII') {
      payload = {
        proposal_step: this.id,
        // name: this.commentForm.get('vendor')?.value,
        company_name: this.commentForm.get('vendor')?.value,
        name: this.commentForm.get('name')?.value,
        email: this.commentForm.get('email')?.value,
        contact: this.commentForm.get('contactPerson')?.value,
        phone_number: this.commentForm.get('phone')?.value,
        address: this.commentForm.get('address')?.value,
        tax_number: this.commentForm.get('taxNumber')?.value,
        bank_details: this.commentForm.get('bankDetails')?.value,
        status: 1
      };
      url = `/revenue/add/vendor/`
    } else if(this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII'){
      payload = {
        questionnaire: this.questionnaireContent,
    };
      url = `/make1/vendor-identification/`
      
  }

      if (this.questionnaireID) {
      const sub = this.api.putAPI(url + `${this.questionnaireID}/`, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Updated successfully'
          });
          this.getVendorIdentification();
        },
        error: (err) => {
          console.error('Error while saving mapping:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save mapping. Please try again.'
          });
        }
      });
    }else if (this.selectedvendor) {
      const sub = this.api.putAPI(url + `${this.selectedvendor.id}/`, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor added successfully'
          });
          this.visible = false;
          this.commentForm.reset();
          this.selectedVendor = null
          this.getVendorIdentification()
        },
        error: (err) => {
          console.error('Error while saving mapping:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save mapping. Please try again.'
          });
        }
      });
    } else if (this.schemeType != 'makeI' && this.schemeType != 'makeII' && this.schemeType != 'makeIII') {
      const sub = this.api.postAPI(url, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor added successfully'
          });
          this.visible = false;
          this.commentForm?.reset();
          this.systemForm.reset();
          this.getVendorIdentification()
        },
        error: (err) => {
          console.error('Error while saving mapping:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save mapping. Please try again.'
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }
//   onSubmit() {
//   let payload;
//   let url;

//   if (this.schemeType == 'idex') {

//     payload = {
//       proposal_step: this.id,
//       company_name: this.systemForm.get('name')?.value,
//       description: this.systemForm.get('description')?.value,
//       scheme: parseInt(this.payload.scheme)
//     };

//     url = `idex/vendor-identification/`;

//   } else if (this.schemeType == 'tdf') {

//     payload = {
//       step: this.resId,
//       proposal_step: this.id,
//       company_name: this.commentForm.get('vendor')?.value,
//       name: this.commentForm.get('name')?.value,
//       email: this.commentForm.get('email')?.value,
//       contact: this.commentForm.get('contactPerson')?.value,
//       phone_number: this.commentForm.get('phone')?.value,
//       address: this.commentForm.get('address')?.value,
//       tax_number: this.commentForm.get('taxNumber')?.value,
//       bank_details: this.commentForm.get('bankDetails')?.value,
//       status: 1
//     };

//     url = `/tdf/vendor-identification/`;

//   } else if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {

//     payload = {
//       questionnaire: this.questionnaireContent
//     };

//     url = `/make1/vendor-identification/`;

//   } else {

//     payload = {
//       proposal_step: this.id,
//       company_name: this.commentForm.get('vendor')?.value,
//       name: this.commentForm.get('name')?.value,
//       email: this.commentForm.get('email')?.value,
//       contact: this.commentForm.get('contactPerson')?.value,
//       phone_number: this.commentForm.get('phone')?.value,
//       address: this.commentForm.get('address')?.value,
//       tax_number: this.commentForm.get('taxNumber')?.value,
//       bank_details: this.commentForm.get('bankDetails')?.value,
//       status: 1
//     };

//     url = `/revenue/add/vendor/`;
//   }

//   /* ---------------- API CALL SECTION ---------------- */

//   if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {

//     if (this.questionnaireID) {

//       const sub = this.api.putAPI(url + `${this.questionnaireID}/`, payload).subscribe({
//         next: () => {
//           this.messageService.add({
//             severity: 'success',
//             summary: 'Success',
//             detail: 'Vendor added successfully'
//           });
//           this.getVendorIdentification();
//         },
//         error: (err) => {
//           console.error('Error while saving mapping:', err);
//         }
//       });

//       this.subscriptions.add(sub);

//     } else {

//       const sub = this.api.postAPI(url, payload).subscribe({
//         next: () => {
//           this.messageService.add({
//             severity: 'success',
//             summary: 'Success',
//             detail: 'Vendor added successfully'
//           });
//           this.getVendorIdentification();
//         },
//         error: (err) => {
//           console.error('Error while saving mapping:', err);
//         }
//       });

//       this.subscriptions.add(sub);
//     }

//   } else if (this.questionnaireID) {

//     const sub = this.api.putAPI(url + `${this.questionnaireID}/`, payload).subscribe({
//       next: () => {
//         this.messageService.add({
//           severity: 'success',
//           summary: 'Success',
//           detail: 'Vendor added successfully'
//         });
//         this.getData();
//       },
//       error: (err) => {
//         console.error('Error while saving mapping:', err);
//       }
//     });

//     this.subscriptions.add(sub);

//   } else if (this.selectedvendor) {

//     const sub = this.api.putAPI(url + `${this.selectedvendor.id}/`, payload).subscribe({
//       next: () => {
//         this.messageService.add({
//           severity: 'success',
//           summary: 'Success',
//           detail: 'Vendor added successfully'
//         });
//         this.visible = false;
//         this.commentForm.reset();
//         this.selectedVendor = null;
//         this.getVendorIdentification();
//       },
//       error: (err) => {
//         console.error('Error while saving mapping:', err);
//       }
//     });

//     this.subscriptions.add(sub);

//   } else {

//     const sub = this.api.postAPI(url, payload).subscribe({
//       next: () => {
//         this.messageService.add({
//           severity: 'success',
//           summary: 'Success',
//           detail: 'Vendor added successfully'
//         });
//         this.visible = false;
//         this.commentForm?.reset();
//         this.systemForm.reset();
//         this.getVendorIdentification();
//       },
//       error: (err) => {
//         console.error('Error while saving mapping:', err);
//       }
//     });

//     this.subscriptions.add(sub);
//   }
// }

  onEdit(event: any) {
    this.visible = true;
    this.selectedvendor = event.vendor;
    this.commentForm.patchValue({
      vendor: this.selectedvendor.name,
      name: this.selectedvendor.name,
      contactPerson: this.selectedvendor.contact,
      email: this.selectedvendor.email,
      phone: this.selectedvendor.phone_number,
      address: this.selectedvendor.address,
      taxNumber: this.selectedvendor.tax_number,
      bankDetails: this.selectedvendor.bank_details
    });
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }



  generatePDF() { }

  togglePanel(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
  getData() {

    let endpoint;
    if (this.schemeType === 'tdf') {
      endpoint = `/tdf/evaluation/tpr/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`;
    } if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      endpoint = `/make1/eol-documents/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`;
    }
    else if (this.schemeType == 'idex') {
      endpoint = `/idex/evaluation/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`;
    }
    else if (this.schemeType === 'rev') {
      endpoint = `/revenue/upload/dpr/?proposal_step__proposal=${this.stepDetails.proposal}&proposal_step=${this.stepDetails.id}`;
    }
    this.apiService.getAPI(endpoint).subscribe((resp: any) => {
      this.docuemntList = resp;

      const vendorMap = resp?.vender || resp?.vendor || {};

      // if vendorMap is like your sample JSON (object with arrays as values)
      this.winners = Object.values(vendorMap).flat();
      // this.winners = Object.keys(resp.vendor).flatMap((vendorName: string) => {
      //   return resp.vendor[vendorName].map((row: any) => {
      //     row.vendor.name = vendorName;

      //     // ✅ Normalize documents
      //     if (Array.isArray(row.documents)) {
      //       // Case for TDF-like format
      //       row.documents = row.documents.map((doc: string) => ({
      //         fileId: doc,
      //         fileName: doc.split('/').pop()
      //       }));
      //     } else if (row.document) {
      //       // Case for Make-like format
      //       row.documents = [{
      //         fileId: row.document,
      //         fileName: row.document.split('/').pop()
      //       }];
      //     } else {
      //       row.documents = [];
      //     }

      //     return row;
      //   });
      // });
      this.questionnaireContent = resp?.questionnaire ?? this.questionnaireTemplate;
      this.questionnaireID = resp?.id;
      console.log("questionary id", this.questionnaireID);
    });

  }

  setStatus(vendor: any, status: 'Qualify' | 'Disqualify') {
    console.log(vendor, status, 'vendor');
    vendor.vendor_status = status;
    const formData = new FormData();
    formData.append('vendor_status', vendor.vendor_status);
    // formData.append('vendor_eval_id', vendor.id);
    formData.append('vendor_id', vendor.id);

    let url;
    if (this.schemeType === 'tdf') {
      url = `/tdf/evaluation/tpr/`;
    } else if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      // url = `/make1/upload/dpr/`;
      url = `/make1/eol-documents/`;
    } else if (this.schemeType == 'idex' && this.format == 'evaluation') {
      url = `/idex/evaluation/`;
    } else if (this.schemeType == 'idex' &&  ['screening', 'upload'].includes(this.format)) {
      url = `/idex/vendor-identification/`;
    } else if (this.schemeType == 'idex' && this.format == 'pds-pru-evaluation') {
      url = `/idex/upload/compliance/pds-pru/${vendor.entry_id}/`;
    } else {
      url = `/revenue/upload/dpr/`;
    }

    this.apiService.putAPI(url, formData).subscribe(res => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message || 'Vendor updated successfully', });
      if (this.format == 'evaluation') {
        this.getData();
      } else if (this.format == 'pds-pru-evaluation') {
        this.getVenderPsuPruEvaluation();
      } else if (this.format == 'screening') {
        this.getScreenVendorList();
      } else {
        this.getData();
      }
    });
  }

  downloadSampleCsv() {
    const link = document.createElement('a');
    link.href = environment.APIUrl + '/media/sample_csv/applicant_details.csv';
    link.download = 'Applicant Details';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onCsvUpload(event: any) {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.csvfile = file;
  }

  submitCsv() {
    if (!this.csvfile) {
      alert('Please upload a CSV file first.');
      return;
    }

    const formData = new FormData();
    formData.append('step', this.resId);
    formData.append('file', this.csvfile);

    let url;
    if (this.schemeType == 'idex') {
      url = `/idex/vendor-identification/`
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/vendor-identification/`
    } else if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/vendor-identification/`
    } else {
      url = `/revenue/vendor-identification/`
    }

    const sub = this.api
      .postAPI(url, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'File uploaded successfully',
          });
          this.getVendorIdentification(); // refresh the table
        },
        error: (err) => {
          console.error('Error while saving vendor:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save vendor. Please try again.',
          });
          if (err?.error_file_url) {
            const errorFileUrl = `${this.apiUrl}${err.error_file_url}`;
            const link = document.createElement('a');
            link.href = errorFileUrl;
            // extract filename from URL
            const fileName = errorFileUrl.split('/').pop() || 'error_file.csv';
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        },
      });

    this.subscriptions.add(sub);
  }

  clearUpload() {
    this.uploadedFileName = null;
    this.uploadedCsvFile = null;
    this.csvfile = null;
  }

  
  fristStepData:Number;
  challengesData: any;


getVenderPsuPruEvaluation() {
this.apiService
  .getAPI(`/idex/upload/compliance/pds-pru/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`)
  .subscribe((resp: any) => {
    
    console.log("Full API Response:", resp);

    this.fristStepData = resp?.first_step_id ?? null;
    this.challengesData = resp?.problem_statement ?? null;

    const vendorMap = resp?.vendor ?? {};
    console.log("vendorMap:", vendorMap);

    // ✅ Flatten vendor object into array of objects
    let flattenedVendors: any[] = [];

    if (vendorMap && typeof vendorMap === 'object') {
      Object.keys(vendorMap).forEach((vendorName) => {
        const vendorEntries = vendorMap[vendorName]; // array of objects
        vendorEntries.forEach((entry: any) => {
          console.log("Entry ID:", entry.id); 
          if (entry?.vendor) {
            flattenedVendors.push({
              ...entry.vendor, 
              entry_id: entry.id,               // vendor details
              vendor_status: entry.vendor_status, // extra field from entry
              vendor_key: vendorName           // original vendor name key
            });
          }
        });
      });
    }

    console.log("Flattened Vendors Array:", flattenedVendors);
    this.winners = flattenedVendors; // assign flattened array
  });
}
  getPdsPru() {
    this.apiService.getAPI(`/idex/pta/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((resp: any) => {
      const vendorMap = resp?.vendor || {};
      this.winners = Object.values(vendorMap).flat();
    });
  }
  files = {
    'file1': null,
    'file2': null,
  }
  handleFileInput(event: any, fileName: string) {
    const file = event.target.files[0];
    if (file) {
      this.files[fileName] = file;
    }
  }
  submitFiles(): void {
    if (!this.files.file1 || !this.files.file2) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please upload both CSV and ZIP files.'
      });
      return;
    }

    const formData = new FormData();
    formData.append('step', this.resId);
    formData.append('vendor_file', this.files.file1);
    formData.append('briefcase_file', this.files.file2);
    formData.append('agencie_1', this.agencieForm.get('agencie_1')?.value);
    formData.append('agencie_2', this.agencieForm.get('agencie_2')?.value);
    formData.append('agencie_3', this.agencieForm.get('agencie_3')?.value);
    let url: string;
    if (this.schemeType == 'idex') {
      url = `/idex/vendor-identification/`;
    } else if (this.schemeType == 'tdf') {
      url = `/tdf/vendor-identification/`;
    } else if (this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII') {
      url = `/make1/vendor-identification/`;
    } else {
      url = `/revenue/vendor-identification/`;
    }

    const sub = this.api.postAPI(url, formData).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Files uploaded successfully'
        });
        this.files.file1 = null;
        this.files.file2 = null;
        this.agencieForm.reset();
        const fileInput1 = document.getElementById('fileUpload1') as HTMLInputElement;
        const fileInput2 = document.getElementById('fileUpload2') as HTMLInputElement;
        if (fileInput1) fileInput1.value = '';
        if (fileInput2) fileInput2.value = '';
        this.getVendorIdentification();
        // this.filesSubmitted.emit(res);
      },
      error: (err: any) => {
        console.error('Error uploading files:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: err?.error?.message || 'Failed to upload files. Please try again.'
        });
        if (err?.error_file_url) {
          const errorFileUrl = `${this.apiUrl}${err.error_file_url}`;
          const link = document.createElement('a');
          link.href = errorFileUrl;
          const fileName = errorFileUrl.split('/').pop() || 'error_file.csv';
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    });
    this.subscriptions.add(sub);
  }
  tableData: any[] = [];
  role_id = sessionStorage.getItem('user_role_id');
  showSampleDialog: boolean = false;
  showNilRemarks: boolean = false;
  tableColumns: any[] = [
    { field: 'sr_no', header: 'Ser No.', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'challenge_number', header: 'Challenge No', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'applying_as', header: 'Applying as', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'themenetic', header: 'Thematic OC/Problem Statement', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'name', header: 'Name of Applicant', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'gender', header: 'Gender', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'phone_number', header: 'Phone Number', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'email', header: 'Email', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'address', header: 'Address', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'states', header: 'State', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'city', header: 'City', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'company_name', header: 'Company Name', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'designation_applicant', header: 'Designation of Applicant', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'company_website', header: 'Company Website', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'company_portfolio', header: 'Portfolio of the Company', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'innovation_title', header: 'Innovation Title', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'title_innovative', header: 'Title of Innovative Technology', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'nodal_dte', header: 'Nodal Dte', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'recommendations_1', header: 'PI 1 Recommendation', filterType: 'text', filterValue: '', vType: 'status' },
    { field: 'comments_1', header: 'PI 1 Remarks', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'recommendations_2', header: 'PI 2 Recommendation', filterType: 'text', filterValue: '', vType: 'status' },
    { field: 'comments_2', header: 'PI 2 Remarks', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'recommendations_3', header: 'PI 3 Recommendation', filterType: 'text', filterValue: '', vType: 'status' },
    { field: 'comments_3', header: 'PI 3 Remarks', filterType: 'text', filterValue: '', vType: 'text' },
    { field: 'vendor_status', header: 'Status', filterType: 'text', filterValue: '', vType: 'status' },
    { field: 'supporting_doc', header: 'Supporting Doc', filterValue: '', vType: 'supporting_doc' },
  ];
  filterColoum: any[] = [];
  selectedProposals = []
  displayUploadDialog: boolean = false;
  selectedProposal: any;
  showDeleteConfirmDialog: boolean = false;

  getStatusClass(status: string): string {
    // console.log(status, 'status');
    switch (status) {
      case 'Qualify':
        return 'border-green-200 bg-green-100 text-green-700';
      case 'Disqualify':
        return 'border-red-200 bg-red-100 text-red-700';
      case 'Recommended':
        return 'border-green-200 bg-green-100 text-green-700';
      case 'Rejected':
        return 'border-red-200 bg-red-100 text-red-700';
      default:
        return 'border-yellow-200 bg-yellow-100 text-yellow-700';
    }
  }
  
  downloadProposal(proposal: any) {
    this.zipDownloadService.downloadDocsAsZip(proposal?.documents, `${proposal?.oc_folder + "_" + proposal?.challenge_number}.zip`);

  }

  applicantData: any;
  briefcaseData: any;

  /** States as an array so *ngFor works when API returns a string (e.g. "Gujarat") instead of an array. */
  get applicantStatesArray(): any[] {
    const s = this.applicantData?.states;
    if (s == null) return [];
    return Array.isArray(s) ? s : [s];
  }

  openPopup(proposal: any) {
    this.applicantData = proposal;
    this.displayUploadDialog = true;
  }

  deleteProposal(proposal: any) {
    this.selectedProposal = proposal;
    this.showDeleteConfirmDialog = true;
  }


  actionType: string = '';
  openAcceptRejectPopup(action: 'Qualify' | 'Disqualify') {
    this.actionType = action;
    this.selectedProposals.forEach((proposal: any) => {
      this.setStatus(proposal, action as 'Qualify' | 'Disqualify');
    });
    this.selectedProposals = [];
  }

  getLable(key):String{
    if(this.stepDetails.code === "I-UPS")
      return key=='Qualify'? "Declare as winner" : " Not Declare as winner"
    else if(this.stepDetails.code === "I-UP")
      return key=='Qualify'? "Recommend" : " Not Recommend"
    else
      return key == 'Qualify' ? "Qualified" : "Disqualified"
  }
  
//   statusMap: any = {
//   Qualify: 'Upload Responses & shortlisting of applications',
//   Disqualify: 'Upload Responses & Not shortlisting of applications'
// };


//   getStatusLabel(status: string): string {
//   switch (status) {
//     case 'Qualify':
//       return 'Upload Responses & shortlisting of applications';
//     case 'Disqualify':
//       return 'Upload Responses & Not shortlisting of applications';
//     default:
//       return status;
//   }
// }
rfpdata:any;
  getRfpDetails() {
    this.api.getAPI(`/idex/upload/compliance/pds-pru/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((res: any) => {
      this.rfpdata = res.launch_data[0];
      this.challengesData = res.challenge;
      this.commentForm.patchValue({
        start_date: this.rfpdata?.start_date,
        end_date: this.rfpdata?.end_date,
        challenge_status: this.challengesData?.challenge_status,
      });
    });
    
  }
 getValuationFieldVisible(step) {
    return {
      name: false,
      scheme: false,
      organisation: true,
      category: true,
      challenge_brief: true,
      prototype_development: true,
      release_date: true,
      nodal_officer_id: true,
      nodal_precurement: true,
      technology_domain: true,
      problem_statement: true,
      coordinated_agency_id: true,
      requirement: true,
      ip_value: true,
      functional_advantages: true,
      domestic: true,
      substitution: true,
      preliminary_scope: true,
      competitive_solution: true,
      potential_market: true,
      risk_assessment: true,
      mpo_qty: true,
      proposal_id: true,
    }
  }
  


  // Form code 
  
}
